export const RNODE_CASES_URL = "https://rnode.rdvpartners.fr";

/** Shared editorial entries for the menu and the R-Node overview. */
export const RNODE_CASES = [
  {
    "id": "negoce-distribution",
    "label": "Négoce & distribution",
    "tag": "Du stock au client"
  },
  {
    "id": "industrie",
    "label": "Industrie",
    "tag": "De la matière à la commande"
  },
  {
    "id": "menuiserie-aluminium",
    "label": "Menuiserie aluminium",
    "tag": "Du besoin au règlement"
  },
  {
    "id": "architecture",
    "label": "Cabinets d’architecture",
    "tag": "Du programme à la mission"
  },
  {
    "id": "maintenance",
    "label": "Maintenance",
    "tag": "De la demande à l’intervention"
  },
  {
    "id": "multisites",
    "label": "Propreté & services multisites",
    "tag": "Du contrat au terrain"
  },
  {
    "id": "organismes-de-formation",
    "label": "Organismes de formation",
    "tag": "De l’inscription au bilan"
  },
  {
    "id": "conseil-accompagnement",
    "label": "Conseil & accompagnement",
    "tag": "De l’opportunité à la mission"
  }
] as const;

